function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineServices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#F0F6EF",
    style: {
      fill: "#F0F6EF",
      fill: "color(display-p3 0.9412 0.9647 0.9373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 14C24.4288 14 21.9154 14.7624 19.7776 16.1909C17.6398 17.6194 15.9735 19.6497 14.9896 22.0251C14.0056 24.4006 13.7482 27.0144 14.2498 29.5362C14.7514 32.0579 15.9895 34.3743 17.8076 36.1924C19.6257 38.0105 21.9421 39.2486 24.4638 39.7502C26.9856 40.2518 29.5995 39.9944 31.9749 39.0104C34.3503 38.0265 36.3807 36.3603 37.8091 34.2224C39.2376 32.0846 40 29.5712 40 27C39.9964 23.5533 38.6256 20.2488 36.1884 17.8116C33.7512 15.3744 30.4467 14.0036 27 14ZM18.7863 34.3088L19.1013 34.1025C19.3763 33.9211 19.6023 33.6745 19.7591 33.3847C19.9159 33.0948 19.9986 32.7708 20 32.4412L20.0263 27.9125L22.6463 24C22.6591 24.0099 22.6724 24.0191 22.6863 24.0275L25.145 25.6362C25.5571 25.9271 26.0641 26.0508 26.5638 25.9825L30.5 25.4487C30.9854 25.384 31.4302 25.1433 31.75 24.7725L34.5213 21.5525C34.8312 21.1894 35.001 20.7274 35 20.25V19.4587C36.3526 20.8897 37.2956 22.658 37.7304 24.5785C38.1651 26.499 38.0756 28.501 37.4713 30.375L35.4538 28.53C35.1733 28.2726 34.8252 28.1005 34.4503 28.0341C34.0754 27.9677 33.6894 28.0096 33.3375 28.155L29.53 29.7362C29.2116 29.8699 28.9331 30.0833 28.7211 30.3559C28.5092 30.6284 28.371 30.951 28.32 31.2925L28.0213 33.3162C27.9494 33.8034 28.0599 34.2998 28.3313 34.7106C28.6028 35.1214 29.0162 35.4176 29.4925 35.5425L32.175 36.25L32.47 36.5462C30.2795 37.8031 27.7229 38.2667 25.2305 37.8592C22.7382 37.4517 20.4624 36.1978 18.7863 34.3088Z",
    fill: "#55A249",
    style: {
      fill: "#55A249",
      fill: "color(display-p3 0.3333 0.6353 0.2863)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineServices);
export default __webpack_public_path__ + "static/media/onlineServices.c1bb95bfa3bcb82f7b9701e8305dd915.svg";
export { ForwardRef as ReactComponent };